// extracted by mini-css-extract-plugin
export default {"content":"style_content__A5D6A","hero":"style_hero__Q71VO","textWrapper":"style_textWrapper__nTHCM","text":"style_text__3aWg5","text2":"style_text2__T5Uxw"};